import { Container } from './ExperienceRate.style'

import IconWithText from 'components/generic/IconWithText'
import ClockIcon from 'Images/SVG/Clock.svg'
import DollarIcon from 'Images/SVG/DollarCircle.svg'
import { Box } from 'components/generic/HomePageComponents'

const ExperienceRate = ({ payRate, yearsExperience }) => {
  const showExperience = yearsExperience > 0
  const hasRate = payRate?.value > 0 && payRate?.unit
  const rateText = hasRate ? `${payRate?.value}/${payRate?.unit}` : 'Pay negotiable'
  const yearsExperienceText = `${yearsExperience} yrs experience`
  const rateAriaLabel = hasRate ? `$${payRate?.value} per ${payRate?.unit}` : 'Pay negotiable'

  return (
    <Container display='flex' flexDirection='row' backgroundColor='gray.0' p='4' color='gray.6'>
      {showExperience && (
        <Box mr='4'>
          <IconWithText
            iconDimension={{ height: '16px', width: '17px' }}
            iconUrl={ClockIcon}
            text={yearsExperienceText}
          />
        </Box>
      )}
      <Box mr='4'>
        <IconWithText
          iconDimension={{ height: '16px', width: '17px' }}
          iconUrl={DollarIcon}
          text={rateText}
          aria-label={rateAriaLabel}
        />
      </Box>
    </Container>
  )
}

export default ExperienceRate
